import {
    Business_path,
    formNameMapper,
    General_path,
    Study_path,
    Travel_path,
    VisaPurposes,
    Work_path,
} from 'data/constants/constants';

export const getFormPath_v2 = (purpose: string, hasSpouse?: string, hasFamily?: string) => {
    switch (purpose) {
        case VisaPurposes.TRAVEL:
            return getArrayValues(Travel_path(hasSpouse, hasFamily));
        case VisaPurposes.WORK:
            return getArrayValues(Work_path(hasSpouse, hasFamily));
        case VisaPurposes.BUSINESS:
            return getArrayValues(Business_path(hasSpouse, hasFamily));
        case VisaPurposes.STUDY:
            return getArrayValues(Study_path(hasSpouse, hasFamily));
        case VisaPurposes.GENERAL:
            return getArrayValues(General_path(hasSpouse, hasFamily));
        case VisaPurposes.NOPREFERENCE:
            return getArrayValues(General_path(hasSpouse, hasFamily));
        default:
            return getArrayValues(Travel_path(hasSpouse, hasFamily));
    }
};

const getArrayValues = (arr: string[]) => {
    return arr.filter((el) => el !== '');
};

export const getScreenNumber = (formsFilled: { [key: string]: boolean }, purpose: string) => {
    // returns index of last form filled - dont we need hasSp & hasFM? Could use util
    const formPath = getFormPath_v2(purpose);
    const indices = Object.entries(formsFilled).map((val) =>
        val[1] ? formPath.indexOf(formNameMapper[val[0]]) + 2 : 2
    );
    const lastFilledForm = Math.max(...indices, 1);
    const firstNonFilledForm = Math.min(formPath.length, lastFilledForm);
    return firstNonFilledForm;
};
